/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendFriendRequestResponse
 */
export interface SendFriendRequestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SendFriendRequestResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SendFriendRequestResponse
     */
    message: string;
}

/**
 * Check if a given object implements the SendFriendRequestResponse interface.
 */
export function instanceOfSendFriendRequestResponse(value: object): value is SendFriendRequestResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SendFriendRequestResponseFromJSON(json: any): SendFriendRequestResponse {
    return SendFriendRequestResponseFromJSONTyped(json, false);
}

export function SendFriendRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendFriendRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function SendFriendRequestResponseToJSON(json: any): SendFriendRequestResponse {
    return SendFriendRequestResponseToJSONTyped(json, false);
}

export function SendFriendRequestResponseToJSONTyped(value?: SendFriendRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

